import React from "react";

export default function MySQL_MAX() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_MAX</h1>
      <p>This is the MySQL_MAX component generated from the SQL JSON.</p>
    </div>
  );
}
